import React, { memo, useContext, useEffect, useRef, useState } from 'react';

import unicodeJson from './languages/unicode.json';
import enJson from './languages/en.json';

const storeContext = React.createContext({});

export const StoreProvider  = memo(({ children }) => {
    const [store,updateStore] = useState({
        lang: "my",
    });

    useEffect(()=> {
        const text  = store.lang === 'my' ? unicodeJson : enJson;
        updateStoreFunc('text',text);
    },[store.lang])

    const updateStoreFunc  = (storeKey, storeValue, nestedValue, cb) => {
        if(cb) updateStore(cb);
        updateStore((pre) => {
            if (nestedValue !== undefined) {
                return {
                    ...pre,
                    [storeKey]: {
                        ...(pre)[storeKey],
                        ...{[storeValue]: nestedValue},
                    },
                };
            } else {
                return { ...pre, [storeKey] : storeValue };
            }
        });
    }

    return (
        <storeContext.Provider value={{store,updateStoreFunc}}>
            {children}
        </storeContext.Provider>
    );
});


export const useStore = () => {
    const context = useContext(storeContext);
    if (!context) {
      throw new Error('useStore must be used within an StoreProvider');
    }
    return context
};
